// Simple global state for modal (no Context API needed)
class ModalState {
  constructor() {
    this.isVisible = false;
    this.listeners = [];
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  notify() {
    this.listeners.forEach((listener) => listener(this.isVisible));
  }

  show() {
    console.log("[InactivityModal] Showing modal");
    this.isVisible = true;
    this.notify();
  }

  hide() {
    console.log("[InactivityModal] Hiding modal");
    this.isVisible = false;
    this.notify();
  }

  getState() {
    return this.isVisible;
  }
}

// Create singleton instance
export const modalState = new ModalState();

// Make it globally accessible
if (typeof window !== "undefined") {
  window.inactivityModalState = modalState;
}
